<div *ngIf="modelData">


  <header class="contenedor">
    <div class="topbar"></div>
    <div id="logo-hp">
      <img src="assets/img/logo_hp.svg" alt="Logo HP">
    </div>


    <main class="contenedor">
      <!--    DIF #1   -->
      <section>
        <img class="lifestyle-dif" src="{{modelData.headerDesktopUrl}}">
      </section>
    </main>
    <!-- <div id="banner-home" class="desktop" [ngStyle]="{'background-image': 'url('+modelData.headerDesktopUrl+')'}">
       <a id="play-video" (click)="open(content)" *ngIf="videoUrl1"><img src="assets/img/01_banners/play.svg" alt="Botón Play Video"></a>
     </div>

     <div id="banner-home" class="mobile" [ngStyle]="{'background-image': 'url('+modelData.headerMobileUrl+')'}">
       <a id="play-video" (click)="open(content)" *ngIf="videoUrl1"><img src="assets/img/01_banners/play.svg" alt="Botón Play Video"></a>
     </div>-->

    <div class="descrip-producto-principal">
      <h1>{{modelData.nameFirstLine}}</h1>
      <h1>{{modelData.nameSecondLine}}</h1>
      <p style="margin-top:17px">{{modelData.introduccion}}</p>
    </div>
  </header>

  <!--  ESPECIFICACIONES TECNICAS -->
  <section class="cehp-contenedor">
    <h2 class="ft-h2">Especificaciones Técnicas</h2>
    <div id="ficha-tecnica">

      <div class="contenedor-specs" *ngFor="let spec of modelData.allSpecs" [hidden]="!spec.imagen" >
        <img src="{{spec.imagen}}" alt="">
        <h3>{{spec.label}}:</h3>
        <p>{{spec.value}}</p>
      </div>

    </div>
  </section>

  <main class="contenedor">
    <!--    DIF #1   -->
    <section *ngFor="let diferenciador of modelData.diferenciadores">
      <img class="lifestyle-dif" src="{{diferenciador.imagenBody}}" alt="Trabaja todo el día. Disfruta todo el tiempo.">
      <img class="icono-dif" src="{{diferenciador.imagen}}" alt="Batería">
      <div class="textos-dif">
        <h2>{{diferenciador.titulo}}</h2>
        <p>{{diferenciador.descripcion}}</p>
      </div>
    </section>

  </main>
  <section class="cehp-video-yt">
    <iframe width="510" height="310" *ngIf="videoUrl1" [src]="videoUrl1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <iframe width="510" height="310" *ngIf="videoUrl2" [src]="videoUrl2" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </section>
  <section class="cehp-video-yt-md">
    <iframe width="320" height="310" *ngIf="videoUrl1"  [src]="videoUrl1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <iframe width="320" height="310" *ngIf="videoUrl2"  [src]="videoUrl2" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </section>
  <section class="cehp-video-yt-sm">
    <iframe width="240" height="200" *ngIf="videoUrl1" [src]="videoUrl1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <iframe width="240" height="200" *ngIf="videoUrl2"  [src]="videoUrl2" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </section>

  <section class="contenedor" (click)="sendEventDownloadPDF()">
    <a href="https://fichashppervasive.blob.core.windows.net/imagenes/print_and_play.pdf" target="_blank">
      <img class="banner-pdf"    src="assets/img/01_banners/banner-pdf.jpg" alt="">
      <img class="banner-pdf-md" src="assets/img/01_banners/banner-pdf-md.jpg" alt="">
    </a>

  </section>

  <!--  GALERÍA DE IMÁGENES -->


</div>
